var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlertIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 1.125a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75ZM6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Zm.563-9H5.438v3.75h1.125V3ZM5.438 8.625h1.125V7.5H5.438v1.125Z"
})));
export default SvgAlertIcon;